// Cache des dalles et plages LiDAR (Cache API, utilisé par le worker) ; sans Cache API, tout passe par le réseau
const CACHE_NAME = 'grality-lidar-v1';
const INDEX_KEY = 'https://grality.invalid/lidar-cache-index';
const MAX_BYTES = 300 * 1024 * 1024;

let cachePromise = null;
let indexPromise = null;
let queue = Promise.resolve();
let saveTimer = null;

const openCache = () => cachePromise || (cachePromise = typeof caches === 'undefined' ? Promise.resolve(null) : caches.open(CACHE_NAME).catch(() => null));

// Index `[{ key, size, at }]` gardé en mémoire et réécrit au plus une fois par seconde
const getIndex = (cache) => indexPromise || (indexPromise = cache.match(INDEX_KEY).then(response => response ? response.json() : []).catch(() => []));

// Accès en écriture sérialisés dans le worker
const serialize = (task) => {
    const run = queue.then(task);
    queue = run.catch(() => { });
    return run;
};

export const getRangeKey = (url, begin, end) => `${url}${url.includes('?') ? '&' : '?'}grality-range=${begin}-${end}`;

export async function cached(key, fetcher) {
    const cache = await openCache();
    if (cache) {
        try {
            const response = await cache.match(key);
            if (response) return new Uint8Array(await response.arrayBuffer());
        } catch { }
    }

    const data = await fetcher();
    if (cache) store(cache, key, data);
    return data;
}

function store(cache, key, data) {
    serialize(async () => {
        await cache.put(key, new Response(data));
        const index = await getIndex(cache);
        const existing = index.findIndex(entry => entry.key === key);
        if (existing >= 0) index.splice(existing, 1);
        index.push({ key, size: data.byteLength, at: Date.now() });

        let total = index.reduce((sum, entry) => sum + entry.size, 0);
        while (total > MAX_BYTES && index.length > 1) {
            const oldest = index.shift();
            total -= oldest.size;
            await cache.delete(oldest.key);
        }

        clearTimeout(saveTimer);
        saveTimer = setTimeout(() => serialize(() => cache.put(INDEX_KEY, new Response(JSON.stringify(index)))), 1000);
    }).catch(() => { });
}

// Taille et vidage du cache pour l'écran de synchronisation (fil principal ; le worker relira les dalles)
export async function getLidarCacheBytes() {
    if (typeof caches === 'undefined' || !(await caches.has(CACHE_NAME))) return 0;
    const response = await (await caches.open(CACHE_NAME)).match(INDEX_KEY);
    const index = response ? await response.json() : [];
    return index.reduce((total, entry) => total + (entry.size || 0), 0);
}

export async function clearLidarCache() {
    cachePromise = null;
    indexPromise = null;
    if (typeof caches !== 'undefined') await caches.delete(CACHE_NAME);
}
